<app-shared-dialog
  [title]="'settings.manage_account' | translate"
  [options]="dialogOptions"
  (cancel)="close()">
  <div class="connection-details-content" [formGroup]="form">
    <ng-container *ngIf="loading">
      <div class="connection-details__loading">
        <ui-svg-icon svgIcon="refresh-cc" size="large" [class.spin-animation]="loading"></ui-svg-icon>
        <div class="no-content-text">
          <h3>{{ 'smart_inbox.inbox_view.loading_in_progress' | translate }}</h3>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!loading && mailbox">
      <div class="info_section">
        <div class="info_row">
          <span class="info_label">{{ 'settings.smart_inbox_account' | translate }}:</span>
          <span class="info_value">{{ mailbox.email }}</span>
        </div>
        <div class="info_row">
          <span class="info_label">{{ 'settings.smart_inbox_type' | translate }}:</span>
          <span class="info_value">{{ providerLabel(mailbox.provider) }}</span>
        </div>
        <div class="info_row">
          <span class="info_label">{{ 'settings.smart_inbox_owner' | translate }}:</span>
          <span class="info_value">{{ mailbox.mailbox_owner_name || '--' }}</span>
        </div>
        <div class="info_row">
          <span class="info_label">{{ 'settings.smart_inbox_status' | translate }}:</span>
          <span class="info_value">
            <span class="status_dot" aria-hidden="true" [class.connected]="mailbox.connection_status === 'connected'"></span>
            {{ mailbox.connection_status === 'connected' ? ('settings.status_connected' | translate) : ('settings.status_disconnected' | translate) }}
          </span>
        </div>
      </div>

      <h3 class="section_heading">{{ 'settings.general' | translate }}</h3>
      <div class="form_section field_row">
        <label class="field_label inline_label">{{ 'settings.display_name' | translate }}</label>
        <input type="text" class="field_input" formControlName="displayName" [placeholder]="'settings.display_name_optional' | translate" />
      </div>

      <h3 class="section_heading">{{ 'settings.access_settings' | translate }}</h3>
      <div class="access_section">
        <div class="field_row">
          <label class="field_label inline_label">{{ 'settings.sharing' | translate }}</label>
          <span class="sharing_tag" [class.team]="form.get('sharingType')?.value === 'team'" [class.personal]="form.get('sharingType')?.value === 'personal'">{{ (form.get('sharingType')?.value === 'team' ? ('settings.sharing_team' | translate) : ('settings.sharing_personal' | translate)) }}</span>
        </div>

        <div *ngIf="!isTeam" class="logic_info personal_description">
          <span class="info_icon">i</span>
          {{ 'settings.smart_inbox_personal_description' | translate }}
        </div>

        <ng-container *ngIf="isTeam && users.length > 0">
          <div class="users_table_wrap">
            <table class="users_permissions_table">
              <thead>
                <tr>
                  <th class="col_check"></th>
                  <th class="col_user">{{ 'settings.user_name' | translate }}</th>
                  <th class="col_toggle">{{ 'settings.smart_inbox_can_view' | translate }} ({{ canViewLabel }})</th>
                  <th class="col_toggle">{{ 'settings.smart_inbox_can_send' | translate }} ({{ canSendLabel }})</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of users" class="user_row">
                  <td class="col_check">
                    <!-- <label class="checkbox_wrap">
                      <input type="checkbox" [checked]="row.selected" (change)="toggleUserSelection(row)" />
                      <span class="checkmark"></span>
                    </label> -->
                    <mat-checkbox [checked]="row.selected" (change)="toggleUserSelection(row)" [disabled]="mailbox.mailbox_owner_id === row.user.id"></mat-checkbox>
                  </td>
                  <td class="col_user">
                    <div class="user_cell">
                      <span class="user_name">{{ row.user.name }}</span>
                      <span *ngIf="mailbox.mailbox_owner_id === row.user.id" class="owner_badge">{{ 'settings.owner' | translate }}</span>
                    </div>
                  </td>
                  <td class="col_toggle">
                    <mat-slide-toggle
                      [checked]="row.canView"
                      (change)="toggleCanView(row)"
                      [disabled]="mailbox.mailbox_owner_id === row.user.id"
                      [color]="mailbox.mailbox_owner_id === row.user.id ? 'accent' : 'primary'">
                    </mat-slide-toggle>
                  </td>
                  <td class="col_toggle">
                    <mat-slide-toggle
                      [checked]="row.canSend"
                      (change)="toggleCanSend(row)"
                      [disabled]="!row.canView || mailbox.mailbox_owner_id === row.user.id"
                      [color]="mailbox.mailbox_owner_id === row.user.id ? 'accent' : 'primary'">
                    </mat-slide-toggle>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>

      <div class="error_message" *ngIf="error">{{ error }}</div>
    </ng-container>
  </div>

  <div customConfirm class="connection-details-actions">
    <!-- Stays enabled once disconnected: the dialog this opens is also the only way to
         permanently delete the connection from here. -->
    <button type="button" class="btn btn_disconnect" (click)="disconnect()" [disabled]="disconnecting || deleting">
      <mat-icon>delete_outline</mat-icon>
      {{ (mailbox && mailbox.connection_status === 'disconnected'
            ? 'settings.delete_connection'
            : 'settings.disconnect') | translate }}
    </button>
    <button type="button" class="btn btn_primary" (click)="update()" [disabled]="saving">
      {{ 'common.update' | translate }}
    </button>
  </div>
</app-shared-dialog>
